import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/index/Index'
import Products from '@/page/Products/Index'
import Details from '@/page/Products/Details'
import Applications from '@/page/applications/Applications'
import Aboutus from '@/page/aboutus/Aboutus'
import Download from '@/page/download/Download'
import Contacts from '@/page/contact/Contact'
// import OurHistory from '@/page/aboutus/OurHistory'
// import FactoryTour from '@/page/aboutus/FactoryTour'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(Router)

// export default new Router({
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Index,
      meta: { keepAlive: true }
    },
    {
      path: '/products',
      name: 'Products',
      component: Products,
      meta: { keepAlive: true }
    },
    {
      path: '/products-details',
      name: 'ProductsDetails',
      component: Details,
      meta: { keepAlive: true }
    },
    {
      path: '/applications',
      name: 'Applications',
      component: Applications,
      meta: { keepAlive: true }
    },
    {
      path: '/aboutus',
      name: 'About Us',
      component: Aboutus,
      meta: { keepAlive: true }
    },
    {
      path: '/download',
      name: 'Download',
      component: Download,
      meta: { keepAlive: true }
    },
    {
      path: '/contact',
      name: 'Contact Us',
      component: Contacts,
      meta: { keepAlive: true }
    }
    // {
    //   path: '/our-history',
    //   name: 'OurHistory',
    //   component: OurHistory
    // },
    // {
    //   path: '/factory-tour',
    //   name: 'FactoryTour',
    //   component: FactoryTour
    // }
  ]
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  if (to.path === from.path && to.path !== '/') {
    if (to.path === from.path && to.query !== from.query) {
      next()
    }
    return false
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js